import { gql } from "@apollo/client";

export const GET_INSUMO_DETALLE = gql`
query GetInsumoRenderById($idInsumoN: Int!) {
  insumoRenderById (idInsumoN: $idInsumoN) {
    insumo {
     idInsumoN,
      idInsumo,
      descripcionGenerica,
      descripcion,
      presentacionGenerica,
      presentacion,
      cantxPack,
      cantxDia,    
      eleccion,
      pesoUnitario,
      esSap,
      activo,
      validado,
      motivoValidacion,
      unidadVenta,
      fraccionable,
      calorias,
      proteinas,
      idFranjaEtareaNavigation {
        id,
        descripcion
      },      
      idFabricanteNavigation {
        descripcion
      },
      idTipoInsumoNavigation {
        idTipoInsumo,
        codigo,
        descripcion,
        categoria
      },
      idUnidadNavigation {
        descripcion
      },
      idAlergia{
        descripcion
      },
      idInsumoComp {
        idInsumo,
        descripcion
      } 
    },
    insumoPrograma {
      idModuloTipoNavigation {
        abreviacion,
        descripcion
      } 
    },
    insumoTipoAccesos {
      nombre
    },
    insumoProductoTM {
      idInsumo,
      descripcion
    },
    insumoCajas {
      cantidad,
      idInsumoCajaNavigation {
        idInsumo
        descripcion
      }
    } 
  }
}`;